import { Component, inject, signal } from '@angular/core';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  private readonly auth = inject(AuthService);

  email = '';
  password = '';
  rememberMe = true;

  readonly showPassword = signal(false);
  readonly loading = signal(false);
  readonly error = signal<string | null>(null);

  togglePassword(): void {
    this.showPassword.update((v) => !v);
  }

  onSubmit(): void {
    if (!this.email || !this.password) return;
    this.loading.set(true);
    this.error.set(null);
    this.auth.login(this.email, this.password).subscribe({
      error: (err) => {
        this.error.set(err?.error?.message ?? 'Correo o contraseña incorrectos');
        this.loading.set(false);
      },
      complete: () => this.loading.set(false)
    });
  }

  noopSocial(event: Event): void {
    event.preventDefault();
  }
}
